<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            International Student Application System
          </li>
        </ol>
      </div>
    </nav>

    <div class="main form form_4">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <div class="box" :class="{ 'submitted-readonly': isSubmitted }">
          <div class="title">
            <h2>International Student Application System</h2>
            <div class="btn_box">
              <button class="tours_btn" @click="startTour">
                <svg width="28" height="28" viewBox="0 0 28 28">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="_3" data-name="3" width="28" height="28" transform="translate(5575 10526)" fill="none"
                        stroke="#707070" stroke-width="1" />
                    </clipPath>
                  </defs>
                  <g id="icon_instructions" transform="translate(-5575 -10526)" clip-path="url(#clip-path)">
                    <g id="_2" data-name="2" transform="translate(5575.14 10526.5)">
                      <path id="_1" data-name="1"
                        d="M23.14,21.36a1,1,0,0,0,1-1V3.42A1.929,1.929,0,0,0,22.21,1.5H8.69V19.358h-2V1.5H5.93A3.077,3.077,0,0,0,2.86,4.57V22.43c0,.011.006.021.007.032A3.069,3.069,0,0,0,5.934,25.5h17.2a1,1,0,0,0,0-2H5.934a1.07,1.07,0,0,1,0-2.14H23.14Zm-7.751-15a1.007,1.007,0,0,1,1.021,1,1,1,0,0,1-2,0,1,1,0,0,1,.979-1ZM14.41,11.19a1,1,0,0,1,2,0v3.96a1,1,0,0,1-2,0Z"
                        fill="#580d63" />
                    </g>
                  </g>
                </svg>
                Instructions
              </button>
            </div>
          </div>

          <ul class="progress_bar">
            <li v-for="(item, index) in progressItems" :key="index">
              <router-link :to="item.to" :class="['step_box', getStepClass(index)]">
                <div class="step">
                  <p v-if="index != 6">Step {{ index + 1 }}</p>
                  <p v-else>Payment</p>
                  <p>{{ item.title }}</p>
                </div>
                <div class="line"></div>
              </router-link>
            </li>
          </ul>

          <!-- 已提交提示訊息 -->
          <div v-if="isSubmitted" class="bg" style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 15px 20px; margin-bottom: 20px;">
            <p style="margin: 0; color: #856404; font-weight: bold; font-size: 16px;">
              ⚠️ Application submitted and under review. View-only mode.
            </p>
          </div>

          <div class="bg">
            <div class="title_box description">
              <h3>{{ stepContent.title }}</h3>
            </div>

            <div v-if="stepContent.content" class="text_box" id="step1" v-html="stepContent.content"></div>
          </div>

          <div class="bg">
            <div class="block" id="step2">
              <div class="title_box">
                <h3>General Requirements</h3>
              </div>

              <!-- 動態產生通用文件欄位 -->
              <div v-for="(file, index) in generalFiles" :key="file.afId">
                <div class="form-group file_box full" :id="index === 0 ? 'step3' : ''">
                  <label :for="'file-' + file.afId">
                    <span v-if="file.isRequired" class="required">*</span>
                    {{ file.name_EN || file.name }}
                  </label>

                  <div class="file_input" :id="index === 0 ? 'step4' : ''">
                    <input type="file" class="form-control" :id="'file-' + file.afId"
                      @change="handleFileChange($event, file.afId)" :disabled="uploading || isSubmitted"/>
                    <div class="upload">{{ uploading ? 'Uploading...' : 'Upload' }}</div>
                  </div>

                  <div :id="index === 0 ? 'step5' : ''">
                    <!-- 顯示文件說明 -->
                    <div v-if="file.content" v-html="file.content" class="notice"></div>
                    <!-- 顯示已上傳檔案資訊 -->
                    <div v-if="file.simpleFile || file.uploadedFile" class="uploaded-file-info">
                      <a v-if="file.simpleFile" :href="$store.state.src + $store.state.subDirectory + file.simpleFile"
                        target="_blank" class="file_a" style="background-color: #6c757d; color: #FFFFFF;">
                        Simple File
                      </a>
                      <a v-if="file.uploadedFile"
                        :href="$store.state.src + $store.state.subDirectory + file.uploadedFile.url" target="_blank"
                        class="file_a">
                        Uploaded File ({{ formatUploadTime(file.uploadedFile.createTime) }})
                      </a>
                    </div>
                  </div>
                </div>

                <hr v-if="index < generalFiles.length - 1" class="file_hr" />
              </div>

              <!-- 如果沒有通用文件，顯示提示 -->
              <div v-if="generalFiles.length === 0" class="text-center py-4">
                <p class="text-muted">No general documents to upload at this time</p>
              </div>
            </div>
          </div>

          <div class="btn_box">
            <button class="btn" @click="gotoPrev" :disabled="isSubmitted">Previous</button>
            <button class="btn" @click="gotoNext" :disabled="isSubmitted">Next</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from "@/services/applyStudent.js";
import { validateFile } from "@/utils/fileHelper.js";
import { uploadSingleFile } from "@/utils/uploadHelper.js";
import Swal from "sweetalert2";

import { driver } from "driver.js";

export default {
  name: "Form_4",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // 進度步驟
      currentStep: 3, // 表示第4步（index 3）
      progressItems: [
        { to: "/Apply/1", title: "Fill out online application form" },
        { to: "/Apply/2", title: "Apply for a program" },
        {
          to: "/Apply/3",
          title:
            "Fill out Recommenders (Do Not Fill Out Without Notifying Your Recommenders in Advance.)",
        },
        { to: "/Apply/4", title: "Upload Required Documents 1" },
        { to: "/Apply/5", title: "Upload Required Documents 2" },
        { to: "/Apply/Check", title: "Review & Submit" },
        { to: "/Apply/Pay", title: "Pay Application Fee" },
      ],

      driverObj: null,
      arr: [
        {
          element: "#step1",
          popover: {
            description: "Department",
            side: "top",
            align: "start",
          },
        },
        {
          element: "#step2",
          popover: {
            description: "Department",
            side: "bottom",
            align: "start",
          },
        },
        {
          element: "#step3",
          popover: {
            description: "Department",
            side: "top",
            align: "start",
          },
        },
        {
          element: "#step4",
          popover: {
            description: "Department",
            side: "bottom",
            align: "start",
          },
        },
        {
          element: "#step5",
          popover: {
            description: "Department",
            side: "bottom",
            align: "start",
          },
        },
      ],

      // 步驟內容
      stepContent: {
        step: 4,
        title: 'Step 4',
        content: '',
        applyInfo: null
      },

      // 申請表ID
      asId: null,
      isSubmitted: false, // 申請是否已提交

      // 通用文件列表
      generalFiles: [],

      // 上傳中的狀態
      uploading: false,

      aId: null, // 申請學期梯次ID
    };
  },

  watch: {
    // 監控 isSubmitted 狀態並禁用所有表單元素
    isSubmitted: {
      handler(newValue) {
        this.$nextTick(() => {
          this.toggleFormElements(newValue);
        });
      },
      immediate: false
    }
  },

  async mounted() {
    window.scrollTo(0, 0);

    const checkResult = await applyStudentService.checkUserApplication();
    if (!checkResult.success || !checkResult.data ||
      !checkResult.data?.isReview ||
      checkResult.data?.isAgree != 1) {
      Swal.fire({
        icon: "warning",
        title: "Eligibility review not completed",
        text: "Please complete the dual citizenship check and agree to the terms and conditions first.",
        confirmButtonText: "OK"
      }).then(() => {
        this.$router.push("/Profile");
      });
      return;
    }

    await this.loadUserApplication();
    
    await this.loadStepContent();

    // 初始化時檢查並禁用表單元素（如果已提交）
    this.$nextTick(() => {
      if (this.isSubmitted) {
        this.toggleFormElements(true);
      }
    });
  },

  methods: {
    // 載入使用者申請表資料
    async loadUserApplication() {
      const result = await applyStudentService.getUserApplication();
      if (result.success && (!result.data || !result.data.hasApplication)) {
        // 顯示請先完成基本資料並跳轉回Apply/1頁面
        Swal.fire({
          icon: "warning",
          title: "Incomplete Basic Information",
          text: "Please complete your basic information first.",
          confirmButtonText: "OK"
        }).then(() => {
          this.$router.push("/Apply/1");
        });
      }
      if (result.success && result.data) {
        this.aId = result.data.aId;
        this.asId = result.data.asId;
        this.isSubmitted = result.data.isSubmitted || false;
        // 載入通用文件列表
        await this.loadGeneralFiles();
      }
    },

    // 載入通用文件列表
    async loadGeneralFiles() {
      if (!this.asId) return;

      const result = await applyStudentService.getGeneralUploadFiles(this.asId);
      if (result.success && result.data) {
        this.generalFiles = result.data;
      } else {
        console.error('Failed to load general files:', result.message);
      }
    },

    // 載入步驟內容
    async loadStepContent() {
      const result = await applyStudentService.getActiveApplyStepContent(4, this.aId);
      if (result.success && result.data) {
        this.stepContent = result.data;
        if (!this.stepContent.title) {
          this.stepContent.title = 'Step 4';
        }
      } else {
        // 使用預設值
        this.stepContent = {
          step: 4,
          title: 'Step 4',
          content: '',
          applyInfo: null
        };
      }
    },

    // 處理檔案選擇
    async handleFileChange(event, afId) {
      const file = event.target.files[0];
      if (!file) return;

      // 驗證檔案
      const validation = validateFile(file, {
        maxSizeMB: 10,
        allowedTypes: ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx']
      });

      if (!validation.valid) {
        alert(validation.message);
        event.target.value = ''; // 清空選擇
        return;
      }

      // 立即上傳檔案
      await this.uploadFile(file, afId);
    },

    // 上傳單一檔案
    async uploadFile(file, afId) {
      if (this.uploading) {
        return;
      }

      try {
        this.uploading = true;

        // 使用新的上傳方法，會自動顯示進度
        const result = await uploadSingleFile({
          asId: this.asId,
          file: file,
          pId: 0, // 通用文件使用 0
          afId: afId
        });

        // 上傳成功後重新載入文件列表
        if (result.success && result.successCount > 0) {
          await this.loadGeneralFiles();
        }

      } catch (error) {
        console.error('Upload error:', error);
      } finally {
        this.uploading = false;
      }
    },

    // 進度步驟 不同狀態增加不同class
    getStepClass(index) {
      if (index < this.currentStep) {
        return "done"; // 已完成
      } else if (index === this.currentStep) {
        return "filling"; // 目前步驟
      }
    },

    startTour() {
      // 建立 driver 實例，開始導覽
      this.driverObj = driver({
        showProgress: true,
        progressText: "{{current}}/{{total}}",
        showButtons: true,
        nextBtnText: "Next",
        prevBtnText: "Back",
        doneBtnText: "End Tour",
        animate: false,
        steps: this.arr,
      });

      this.driverObj.drive();
    },

    // 取得已上傳檔案的資訊
    getUploadedFile(afId) {
      const file = this.generalFiles.find(f => f.afId === afId);
      return file?.uploadedFile || null;
    },

    // 檢查是否已上傳
    isFileUploaded(afId) {
      return this.getUploadedFile(afId) !== null;
    },

    // 格式化上傳時間
    formatUploadTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-TW');
    },

    // ========== 頁面導覽 ==========

    /**
     * 回到上一頁（Form 1）
     */
    gotoPrev() {
      this.$router.push("/Apply/3").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 前往下一頁（Form 3）
     */
    gotoNext() {
      this.$router.push("/Apply/5").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 切換表單元素的禁用狀態
     * @param {boolean} disable 是否禁用
     */
    toggleFormElements(disable) {
      // 使用 setTimeout 確保 DOM 已完全渲染
      setTimeout(() => {
        const container = document.querySelector('.box');
        if (!container) return;

        // 禁用所有 input (包含 text, radio, checkbox, file 等)
        const inputs = container.querySelectorAll('input:not(.tours_btn)');
        inputs.forEach(input => {
          input.disabled = disable;
        });

        // 禁用所有 select
        const selects = container.querySelectorAll('select');
        selects.forEach(select => {
          select.disabled = disable;
        });

        // 禁用所有 textarea
        const textareas = container.querySelectorAll('textarea');
        textareas.forEach(textarea => {
          textarea.disabled = disable;
        });

        // 禁用所有按鈕 (除了使用說明按鈕)
        const buttons = container.querySelectorAll('button:not(.tours_btn):not(.head-btn)');
        buttons.forEach(button => {
          button.disabled = disable;
        });
      }, 100);
    },
  },
};
</script>

<style scoped>
/* 當表單已提交時,禁用所有輸入元素 */
.submitted-readonly input,
.submitted-readonly select,
.submitted-readonly textarea,
.submitted-readonly button:not(.tours_btn) {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-input,
.submitted-readonly input[type="radio"],
.submitted-readonly input[type="checkbox"] {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-label {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}
</style>
